import React from 'react';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';

export interface SelectionListItem {
  title?: string;
  system?: string;
  disabled?: boolean;
  backgroundImage?: string;
  identifier?: string;
}

interface SelectionListProps {
  title: string;
  items: SelectionListItem[];
  onItemSelection: (item) => void;
  selectedItem: SelectionListItem;
}

const SelectionList: React.FC<SelectionListProps> = (props) => {
  const classes = useStyles();

  const handleClick = (item) => {
    if (item.disabled) {
      return;
    }

    props.onItemSelection(item);
  };

  return (
    <>
      <div className={classes.root}>
        {props.title && (
          <Typography variant={'subtitle1'} className={classes.redText}>
            {t(props.title)}
          </Typography>
        )}
        <List className={classes.listRoot}>
          {props.items.map((item) => {
            const label = item.title;
            const rowKey = item.identifier ?? item.title ?? label;
            return (
              <ListItem
                key={rowKey}
                disabled={item.disabled}
                selected={item === props.selectedItem}
                className={classes.listItem}
              >
                {' '}
                <ListItemText
                  className={clsx(classes.listText, item.disabled && 'inactive')}
                  onClick={() => handleClick(item)}
                >
                  {label}
                </ListItemText>{' '}
              </ListItem>
            );
          })}
        </List>
      </div>
    </>
  );
};

export default SelectionList;
